// extracted by mini-css-extract-plugin
export default {"searchKeyControlContainer":"searchKeyControlContainer---N9p8x","searchKeyControlElement":"searchKeyControlElement---nB3_9"};